export default __webpack_public_path__ + "static/media/summary.673d6260.svg";